<!-- Pug Template -->
<template lang="pug">
.AppStatBlock
	.AppStatBlock-Row
		.AppStatBlock-Highlight
			h3(
				:style="h3Style"
			) {{ series.options.title }}
			.AppStatBlock-LargeNumber {{ currentRate }}%

		.AppStatBlock-Small
			table.AppStatBlock-Stats
				tbody
					tr.AppStatBlock-Stat
						th.AppStatBlock-StatLabel 1-Wk change
						td.AppStatBlock-StatValue 
							span(
								v-if="oneWeekChange < 0"
								v-html="svg.down"
							)
							span(
								v-if="oneWeekChange > 0"
								v-html="svg.up"
							) 
							span {{ oneWeekChange }}

					tr.AppStatBlock-Stat
						th.AppStatBlock-StatLabel 1-Yr change
						td.AppStatBlock-StatValue 
							span(
								v-if="oneYearChange < 0"
								v-html="svg.down"
							)
							span(
								v-if="oneYearChange > 0"
								v-html="svg.up"
							)
							span {{ oneYearChange }}

					tr.AppStatBlock-Stat
						th.AppStatBlock-StatLabel Monthly avg.
						td.AppStatBlock-StatValue {{ oneMonthAverage }}%
					tr.AppStatBlock-Stat
						th.AppStatBlock-StatLabel 52-Wk avg.
						td.AppStatBlock-StatValue {{ oneYearAverage }}%
	
	.AppStatBlock-RangeContainer
		.AppStatBlock-RangeLabel 52 Week Range
		.AppStatBlock-Range
			div {{ oneYearLow}}%
			.AppStatBlock-RangeBar(
				:style="rangeBarStyle"
			)
				.AppStatBlock-RangeBarLine(
					:style="rangeBarLineStyle"
				)
			div {{ oneYearHigh }}%


</template>

<!-- Script -->
<script>
export default {
	
	props: {
		series: {
			type: Object
		}
	},

	data(){
		return {
			svg: {
				down: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>',
				up: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/></svg>'
			}
		}
	},

	computed: {
		currentRate(){
			const current = this.getPointByLookbackWeek(0);
			return current.y;
		},
		oneWeekChange(){
			return this.change(1)
		},
		oneYearChange(){
			return this.change(52)
		},
		oneMonthAverage(){
			return this.average(4)
		},
		oneYearAverage(){
			return this.average(52)
		},
		oneYearHigh(){
			let ret;
			for( let i=0; i<52; i++){
				let value = this.getPointByLookbackWeek(i).y;
				ret = ret == undefined ? value : Math.max(ret, value);
			}
			return ret;
		},
		oneYearLow(){
			let ret;
			for( let i=0; i<52; i++){
				let value = this.getPointByLookbackWeek(i).y;
				ret = ret == undefined ? value : Math.min(ret, value);
			}
			return ret;
		},
		h3Style(){
			return {
				color: this.series.color
			}
		},
		rangeBarStyle(){
			const percent = (this.currentRate - this.oneYearLow) / (this.oneYearHigh - this.oneYearLow);
			return {
				backgroundColor: this.series.color
			}
		},
		rangeBarLineStyle(){
			const percent = (this.currentRate - this.oneYearLow) / (this.oneYearHigh - this.oneYearLow);
			return {
				left: (percent*100)+'%'
			}
		}
	},

	methods : {
		getPointByLookbackWeek(week){
			return this.series.data[this.series.data.length-1 - (week||0)];
		},

		change(months){
			const current = this.getPointByLookbackWeek(0);
			const previous = this.getPointByLookbackWeek(months);
			return Math.round( 100 * (current.y-previous.y)) / 100;
		},

		average(months){
			let total = 0;
			for(let i=0; i<months; i++){
				total += this.getPointByLookbackWeek(i).y;
			}
			return Math.round( 100 * (total/months) ) / 100;
		}
	},

	created(){
		
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss">
.AppStatBlock {
	&-Row{
		display: flex;
		margin-left: -15px;
		margin-right: -15px;
		> div {
			flex: 1 1 auto;
			padding: 0 15px;
		}
	}
	
	&-Highlight {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	&-Small {
		font-size: 0.9rem;
	}

	h3 {
		display: inline-block;
		border-bottom: 6px solid currentColor;
		margin-bottom: 0;
		margin-top: 0;
		font-size: 1.5rem;
		font-weight: 400;
	}

	&-LargeNumber {
		color: #717171;
		font-size: 3rem;
		font-weight: 600;
	}
	&-Stats {
		width: 100%;
	}
	&-StatLabel {
		text-align: left;
		font-weight: 400;
		white-space: nowrap;
	}
	&-StatValue {
		text-align: right;
		font-weight: 400;
		white-space: nowrap;
		svg {
			height: 0.8em;
			margin-right: 2px;
		}
	}
	&-RangeContainer {
		display: flex;
		justify-content: space-between;
		border-top: 1px solid #e2e2e2;
		padding-top: 20px;
		margin-top: 10px;
		font-size: 0.9em;
		font-weight: 400;
		padding-left: 10px;
	}
	&-Range {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	&-RangeBar {
		height: 20px;
		width: 80px;
		background: #C0DD95;
		margin: 0 10px;
		position: relative;
	}
	&-RangeBarLine {
		width: 2px;
		background: #717171;
		
		position: absolute;
		left: 0;
		top: -40%;
		bottom: -40%;
		margin-left: -2px;

	}
}
</style>